import { Alert, Stack } from "@mantine/core";
import { AlertPresets } from "../../../../../../../mantine/mantinePresets";
import type { MeterPlausibility } from "../../../../../../../utils/backend-types";
import { MeterChecks } from "../MeterChecks/MeterChecks";

interface MeterInfoProps {
  plausibility: MeterPlausibility | undefined;
}

function MeterInfo({ plausibility }: MeterInfoProps) {
  if (!!plausibility && plausibility.plausibility === false) {
    return (
      <Alert className="MeterInfo" color={AlertPresets.warning.color} mb="md">
        <Stack>
          <MeterChecks
            label="Einspeisung"
            problems={plausibility.failed_generation_checks}
          />
          <MeterChecks
            label="Entnahme"
            problems={plausibility.failed_consumption_checks}
          />
        </Stack>
      </Alert>
    );
  }

  return null;
}
export { MeterInfo, MeterInfoProps };
